import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

// Estado vazio consistente.
export const EmptyState = ({ icon: Icon, title, description, action, className }) => (
  <div
    data-testid="empty-state"
    className={cn("flex flex-col items-center justify-center rounded-xl border border-dashed border-line bg-surface/50 px-6 py-14 text-center", className)}
  >
    {Icon && (
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-xl border border-line bg-white/[0.02] text-muted-foreground">
        <Icon className="h-6 w-6" />
      </div>
    )}
    <h3 className="font-heading text-base font-semibold text-foreground">{title}</h3>
    {description && <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">{description}</p>}
    {action && (
      <div className="mt-5">
        {typeof action === "object" && action.label ? (
          <Button onClick={action.onClick} data-testid="empty-state-action">{action.label}</Button>
        ) : action}
      </div>
    )}
  </div>
);
